import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'Admin Sign In | Hindustan Pencils';
  }, []);
  if (user) return <Navigate to="/admin" replace />;

  async function submit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      navigate(location.state?.from?.pathname || '/admin', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-brand-panel">
        <div className="login-brand"><img src="/images/logo.png" alt="Hindustan Pencils Admin" /></div>
        <div>
          <span className="login-eyebrow">CHANNEL PARTNER MANAGEMENT</span>
          <h1>Manage your channel network with clarity.</h1>
          <p>Track distributor and super stockist enquiries and maintain your location master from one secure workspace.</p>
        </div>
        <small>© 2026 Hindustan Pencils. Admin access only.</small>
      </section>
      <section className="login-form-panel">
        <form className="login-card" onSubmit={submit}>
          <div className="login-mobile-brand"><img src="/images/logo.png" alt="Hindustan Pencils Admin" /></div>
          <span className="login-eyebrow">WELCOME BACK</span>
          <h2>Sign in to Admin</h2>
          <p>Enter your account details to continue.</p>
          <label>Email address
            <input type="email" required autoComplete="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="admin@company.com" />
          </label>
          <label>Password
            <input type="password" required autoComplete="current-password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Enter your password" />
          </label>
          {error && <div className="login-error">{error}</div>}
          <button disabled={submitting}>{submitting ? 'Signing in...' : 'Sign in securely →'}</button>
          <small>Only authorized users can access this admin panel.</small>
        </form>
      </section>
    </main>
  );
}

export default Login;
